module.exports = __webpack_public_path__ + "assets/img/modplug_player_title.1b5604af.png";